import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `ControlSangre/imprimirControlSangre`, method: 'POST', body: values, token: token})
}